module.exports = __webpack_public_path__ + "img/20200625_132201.90048a58.jpg";